import { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectSelectedTenantId } from "../store/user/selectors";
import { getFoldersByTenantId } from "../store/spreadsheet/thunks";
import { selectSpreadsheetState } from "../store/spreadsheet/selectors";

export const useTenantSpreadsheet = () => {
  const dispatch = useDispatch();
  const selectedTenantId = useSelector(selectSelectedTenantId);
  const { foldersByTenants, loading, selectedFolderId } = useSelector(
    selectSpreadsheetState,
  );

  useEffect(() => {
    if (selectedTenantId && !foldersByTenants?.[selectedTenantId]) {
      dispatch(
        getFoldersByTenantId({
          tenant_id: selectedTenantId,
        }),
      );
    }
  }, [selectedTenantId, foldersByTenants]);

  const folders = useMemo(() => {
    return foldersByTenants[selectedTenantId] || [];
  }, [foldersByTenants, selectedTenantId]);

  return {
    folders,
    loading,
    selectedTenantId,
    selectedFolderId,
    selectedFolder: folders[selectedFolderId || undefined] || null,
  };
};
